import React, { Component } from 'react'

import PropTypes from 'prop-types'

import Modal from 'react-bootstrap-modal'

import EventForm from './../Event'

export default class AddEvent extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    dates: PropTypes.arrayOf(PropTypes.object),
    POI: PropTypes.object,
    currentDay: PropTypes.number
  }

  static defaultProps = {
    isOpen: false
  }

  render() {
    const { isOpen, onClose, dates, currentDay } = this.props

    return (
      <Modal show={isOpen} onHide={() => onClose()} dialogClassName="event-modal" aria-labelledby="ModalHeader">
        <Modal.Body>
          <EventForm
            user={this.props.user}
            isFluid={true}
            dates={dates}
            initialDay={currentDay}
            POIData={this.props.POI}
            onSave={(event, dayIndex) => onClose(true, event, dayIndex)}
          />
          <i className="event-modal__close icon-close" onClick={() => onClose()} />
        </Modal.Body>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// src/components/TripPlanner/AddEventModal.js